export const queryKeys = {
  COMPANY_REALTOR_SUGGESTION: 'COMPANY_REALTOR_SUGGESTION',
  COMPANY_REALTOR_AUTO_SELECT: 'COMPANY_REALTOR_AUTO_SELECT',
  REALTOR_BALANCE: 'REALTOR_BALANCE',
  REALTOR_BALANCE_CARD: 'REALTOR_BALANCE_CARD'
};
